/**
 * DeviceIdManager.ts
 * Talkroute
 *
 * Created by Vel Genov on 12-December-2020
 * Copyright (c) 2020 Talkroute. All right reserved.
 */

import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";

/**
 * Return a device ID for this web browser.
 * 
 * The device ID is auto generated using uuidv4 and then stored.
 * The next time the device ID is requested, the stored version is returned
 */
const getDeviceID = () => {
    let deviceId = Cookies.get("deviceId");
    if (!deviceId) {
        deviceId = uuidv4();
      Cookies.set("deviceId", deviceId, {
        expires: 365 * 50
      });
    }
    return deviceId;
};

export default getDeviceID;
